import React, { useRef, useEffect } from 'react';
import { FocusManager } from 'wix-rich-content-ui-components';
import { s as styleInject } from '../../style-inject.es-e7b07dd7.js';

var css_248z = ".qzsiX{box-sizing:border-box;display:flex;flex-direction:column;width:162px;z-index:10}[dir] .qzsiX{background-color:#fff}.qzsiX *,.qzsiX :after,.qzsiX :before{box-sizing:inherit}.qzsiX input{box-sizing:border-box}@supports not (contain:inline-size){@media only screen and (max-width:640px){.qzsiX{width:100%}}}@container (width < 640px){.qzsiX{width:100%}}.fjUEk{align-items:flex-start;align-items:center;display:flex;flex-direction:column;width:100%}[dir] .fjUEk{padding:8px 0}";
var styles = {"modal":"qzsiX","dropdownModalOptionsWrapper":"fjUEk"};
styleInject(css_248z);

const DropdownModal = ({ options, jsdomMode, dataHook }) => {
  const panelRef = useRef(null);
  useEffect(() => {
    const ref = panelRef.current;
    setTimeout(() => ref.focus(), 0);
  }, []);
  return /* @__PURE__ */ React.createElement("div", { tabIndex: -1, className: styles.modal, "data-hook": dataHook }, /* @__PURE__ */ React.createElement(FocusManager, { jsdomMode }, /* @__PURE__ */ React.createElement(
    "div",
    {
      tabIndex: 0,
      ref: panelRef,
      "data-hook": "dropdown-modal-options-wrapper",
      className: styles.dropdownModalOptionsWrapper
    },
    options
  )));
};

export { DropdownModal as default };
//# sourceMappingURL=DropdownModal.js.map
